import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../authentication/authentication.service';
import { translations } from 'src/i18n/translations';
import { SharedService } from '../services/shared.service';

export const INVALIDATABLE_CREDENTIALS = 'Could not validate credentials';
export const INVALID_TOKEN = 'Invalid token header. No credentials provided.';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private cookieService: CookieService,
    private location: Location,
    private router: Router,
    private sharedService: SharedService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          (error.status === 401 || error.status === 403) &&
          (error.error.detail === INVALIDATABLE_CREDENTIALS || error.error.detail === INVALID_TOKEN)
        ) {
          if (this.cookieService.get('access_token')) {
            this.authService.revokeToken().subscribe(() => {
              this.authService.removeCookies();
              this.location.go('');
              if (error.error.detail === INVALID_TOKEN) {
                this.sharedService.showError(translations[this.sharedService.language].expiredTokenError);
              }
              return EMPTY;
            });
          } else {
            this.authService.checkIsUserAuthenticated();
            this.location.go('');
            return EMPTY;
          }
        } else if (error.status >= 500) {
          this.sharedService.showError(translations[this.sharedService.language].serverError);
          return EMPTY;
        } else if (error.status === 404) {
          this.router.navigate(['/page-not-found']);
          throw error;
        }

        throw error;
      })
    );
  }
}
